module.exports = __webpack_public_path__ + "assets/d1b590508beb29c2db2eda6f7618e852.png";